module.exports = __webpack_public_path__ + "img/norms1.65a26ca2.png";